// ANCHOR Base
import { Block } from 'baseui/block';
import { HeadingLarge, LabelLarge } from 'baseui/typography';

// ANCHOR Models
import {
  useFormSubmissionQuestionItemData,
} from '@lyon/scoped-models/answer/FormSubmissionQuestionItem';
import { useFormData } from '@lyon/scoped-models/form/FormData';

// ANCHOR Utils
import { formatCountLabel } from '@lyon/utils/extras/formatCountLabel';

// ANCHOR Components
import { constant } from '@lyon/components/utils/constant';
import { Loader } from '@lyon/components/utils/Loader';
import { LyonViewAnswerFormQuestionItemAnswer } from './LyonViewAnswerFormQuestionItemAnswer';
import { LyonViewAnswerFormQuestionCorrectAnswer } from './LyonViewAnswerFormQuestionCorrectAnswer';
import { LyonViewAnswerFormQuestionStatusIcon } from './LyonViewAnswerFormQuestionStatusIcon';
import { LyonViewAnswerFormQuestionRemark } from './LyonViewAnswerFormQuestionRemark';

// ANCHOR Styles
import {
  DISABLED, BLOCK, HEADING, QUESTION, SCORE,
} from './styles';

export const LyonViewAnswerFormQuestionItem = constant(() => {
  const { data } = useFormSubmissionQuestionItemData();
  const form = useFormData();

  if (!form) {
    return <Loader />;
  }

  if (data.question.type === 'spacer') {
    return null;
  }

  const studentScore = data.finalScore ?? data.scoreBeforeRegrade;
  const highestScore = formatCountLabel(data.question.pointsPossible, 'point');
  const showAfterRegrade = form.showAfterRegrade
    ? data.finalScore != null
    : true;

  return (
    <Block overrides={BLOCK}>
      <Block overrides={QUESTION}>
        <HeadingLarge
          marginTop={0}
          marginBottom={0}
          overrides={form.textSelection ? HEADING : DISABLED}
        >
          <LyonViewAnswerFormQuestionStatusIcon />
          {data.question.name}
        </HeadingLarge>
        {
          form.showScore && showAfterRegrade && (
            <LabelLarge overrides={SCORE}>
              {`${studentScore}/${highestScore}`}
            </LabelLarge>
          )
        }
      </Block>
      <LyonViewAnswerFormQuestionItemAnswer />
      {
        form.showCorrectResponse
        && showAfterRegrade
        && data.state === 'incorrect'
        && <LyonViewAnswerFormQuestionCorrectAnswer />
      }
      <LyonViewAnswerFormQuestionRemark />
    </Block>
  );
});
